module.exports = __webpack_public_path__ + "img/广州冷库 (2).293a3a9c.jpg";